// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._1ujaexQ-0fLkw2 {\n  background: #DFE1E6;\n  border-radius: 3px;\n  padding: 2px 4px;\n}\n._1ujaexQ-0fLkw2:hover {\n  background: #C1C7D0;\n}\n.UzD5hXMokYkhgq {\n  height: 14px;\n  margin-right: 3px;\n  vertical-align: middle;\n  width: 14px;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"knownServiceLink": "_1ujaexQ-0fLkw2",
	"knownServiceIcon": "UzD5hXMokYkhgq"
};
export default ___CSS_LOADER_EXPORT___;
